module.exports = __webpack_public_path__ + "static/HeroVideoImage-3890d7d17d0bf1456dc7baffe6d106f2.jpg";